module.exports = __webpack_public_path__ + "static/media/d2.8da17b8d.jpg";